import { useContext, useEffect, useState } from "react"
import { DContext } from "../../../../../context/Datacontext";
import { fetchPrimarySkills } from "../../../../services/Candidate/Profile/fetchCandidateDetails"
import SecondarySkill from "./SecondarySkill"
import { useLocation, useNavigate } from "react-router-dom"
import { FiEdit2 } from "react-icons/fi";
import { FaEye, FaSearch } from "react-icons/fa";


function Skills({ candidate, currentUser }) {

    const [primarySkill, setPrimarySkill] = useState(null)
    const [viewSkills, setviewSkills] = useState(null);
    const [primaryCurrentPage, setPrimaryCurrentPage] = useState(1);
    const [rowsPrimaryPerPage, setPrimaryRowsPerpage] = useState(5);
    const [totalPrimaryPage, setTotalPrimaryPage] = useState(0);
    const [totalPrimarySkill, setTotalPrimarySkill] = useState(0)
    const { BeURL, showAlert } = useContext(DContext)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        setPrimaryCurrentPage(1)
    }, [rowsPrimaryPerPage])

    useEffect(() => {
        const fetchPrimarySkill = async () =>
            await fetchPrimarySkills(BeURL, candidate._id, primaryCurrentPage, rowsPrimaryPerPage, setTotalPrimarySkill, setTotalPrimaryPage, setPrimarySkill, showAlert)

        fetchPrimarySkill()
    }, [primaryCurrentPage, rowsPrimaryPerPage, BeURL])

  

    const handlePagination = (dir) => {
        if (dir === 'prev' && primaryCurrentPage > 1) {
            setPrimaryCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && primaryCurrentPage < totalPrimaryPage) {
            setPrimaryCurrentPage(prev => prev + 1);
        }
    }

    const openView = async (id) => {

        setviewSkills(primarySkill.find(skill => skill._id === id))
    };
    return (
        <div className="rounded-md shadow-lg p-6 ">

            {/* {
                Boolean(primarySkill?.length) && */}
            <>
                <div className="flex justify-between items-center my-2">
                    <h3 className="font-semibold text-lg md:text-xl">Primary Skills</h3>
                   <FiEdit2 className="text-primary-500 text-xl font-bold" onClick={() => navigate(`/update-account/skills?inverse=${true}&candidateId=${candidate?._id}`, { state: { from: location.pathname, active: 'Skills' } })} />
                </div>
                <div className="flex flex-col max-w-full overflow-x-auto sh">
                    <div className="overflow-y-auto max-h-[400px]"> {/* Scroll if >15 rows */}
                        <table className="w-full  rounded-lg  border-separate border-spacing-y-2">
                            <thead className="bg-purple-100 text-secondary-300 sticky top-0 z-10">
                                <tr className="shadow shadow-blue-100 font-semibold ">
                                    <th className="p-2 rounded-l-lg">Skills/ Tools</th>
                                    <th className=" hidden md:table-cell p-2 ">Experiences</th>
                                    <th className="hidden md:table-cell p-2">Last Used</th>
                                    <th className=" p-2"><span className="hidden md:block">Version</span><span className="md:hidden">Action</span></th>
                                </tr>
                            </thead>
                            <tbody className=""> {/* adds spacing between rows */}
                                {(primarySkill && primarySkill?.length > 0) ? (primarySkill?.map((skill, i) => (
                                    <tr
                                        key={i}
                                        className="shadow shadow-blue-50 bg-white hover:bg-gray-50 transition text-center text-sm font-medium"
                                    >
                                        <td className="p-2 rounded-l-lg">{skill.skill.charAt(0).toUpperCase() + skill.skill.slice(1)}</td>
                                        <td className="p-2  hidden md:table-cell">
                                            {(skill?.experience &&
                                                Object.entries(skill?.experience).length > 0 &&
                                                (skill?.experience?.year || skill?.experience?.month)) ?
                                                `${skill.experience.year || 0} years, ${skill.experience.month || 0} months` :'-'}
                                        </td>
                                        <td className="p-2  hidden md:table-cell">{skill?.lastUsed || "NA"}</td>
                                        <td className="p-2 rounded-r-lg"> <span className="hidden md:block">{skill?.version || "NA"}</span><span className="md:hidden"> <button
                                            onClick={() => openView(skill._id)}
                                            className="text-slate-600 hover:text-slate-800"
                                            title="View"
                                        >
                                            <FaEye />
                                        </button>
                                        </span></td>
                                    </tr>
                                ))) : (<tr
                                    className="shadow shadow-blue-50 bg-white hover:bg-gray-50 transition text-center text-sm font-medium"
                                >
                                    <td colSpan={4} className="text-center p-2">No Data Available!</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/* Pagination */}
                <div>
                    <div className="mx-auto mt-7 flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-3">
                        <div className="flex items-center gap-2">
                            <label htmlFor="recordsPerPage" className="text-sm">
                                Records per page:
                            </label>
                            <select
                                id="recordsPerPage"
                                value={rowsPrimaryPerPage}
                                onChange={(e) => setPrimaryRowsPerpage(parseInt(e.target.value, 10))}
                                className="ml-2 px-3 py-1 border rounded-lg text-sm"
                            >
                                {[5, 10, 25, 50, 75, 100].map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex justify-center items-center gap-4 mt-4">
                            <span
                                className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${primaryCurrentPage === 1 ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                                    }`}
                                onClick={() => handlePagination("prev")}
                            >
                                chevron_left
                            </span>
                            <span className="text-sm md:text-base">
                                {primaryCurrentPage} of {totalPrimaryPage}
                            </span>
                            <span
                                className={`material-symbols-outlined text-3xl md:text-4xl text-primary-400 ${primaryCurrentPage === totalPrimaryPage || totalPrimaryPage === 0
                                    ? "cursor-not-allowed opacity-50"
                                    : "cursor-pointer"
                                    }`}
                                onClick={() => handlePagination("next")}
                            >
                                chevron_right
                            </span>
                        </div>
                        <div className="text-sm">Total Primary Skills: {totalPrimarySkill}</div>
                    </div>

                </div>
            </>
            {/* } */}

            <SecondarySkill candidate={candidate} currentUser={currentUser} FaEye ={FaEye}/>

            {
                viewSkills && (
                    <div className={`fixed inset-0 z-50 bg-black/30 ${viewSkills && 'flex'} md:hidden items-center justify-center `}>
                        <div className="bg-white p-6 rounded-lg max-w-sm w-full space-y-2">
                            <h3 className="text-xl font-semibold text-primary-400">Primary Skills</h3>
                            {["_id", "skill", "experience", "lastUsed", "version"].map((k) => (
                                <div key={k}>
                                    <span className="font-medium">
                                        {k === "_id" ? "ID" : k.at(0).toUpperCase() + k.slice(1).replace(/([A-Z])/g, " $1")}:
                                    </span>{" "}
                                    <span>
                                        {k === "_id" ? (
                                            viewSkills?._id
                                        ) : k === "experience" ? (
                                                viewSkills?.experience &&
                                                    Object.keys(viewSkills.experience).length > 0 ? (
                                                        `${viewSkills.experience.year || 0} years, ${viewSkills.experience.month || 0} months`
                                            ) : (
                                                "-"
                                            )
                                        ) : (
                                            viewSkills?.[k] || "-"
                                        )
                                        }
                                       
                                    </span>

                                </div>
                            ))}
                            <button
                                onClick={() => setviewSkills(null)}
                                className="mt-4 px-4 py-2 bg-primary-400 text-white rounded"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )
            }

        </div >
    )
}

export default Skills